import { render, staticRenderFns } from "./goods-edit.vue?vue&type=template&id=85dd7a02&scoped=true&"
import script from "./goods-edit.vue?vue&type=script&lang=js&"
export * from "./goods-edit.vue?vue&type=script&lang=js&"
import style0 from "./goods-edit.vue?vue&type=style&index=0&id=85dd7a02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dd7a02",
  null
  
)

export default component.exports